// extracted by mini-css-extract-plugin
module.exports = {"container":"miniAddressCard_container__1w4MF","address-details":"miniAddressCard_address-details__3_VqH"};